// Keep in step with apps/core-api/vatix/entities/types.py, which enforces the same limit.
export const MAX_PIPELINE_STAGES = 10;
